/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Requirement/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Info from './Info/index'
import React from 'react'
import Skipped from './Skipped/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Requirement({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/CheckRequirements/Requirements/Requirement"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Requirement.Vertical"
  data-view-path={viewPath}
 style={{'--mb-1-2oH0XH': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<Info
  viewPath={`${viewPath}/Info`}
/>
<Skipped
  viewPath={`${viewPath}/Skipped`}
/>
</div>
{children}
</React.Fragment>)
}